import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ProjectProfileDialog from '../../../components/dialogs/ProjectProfile';
import {
  getProjectProfileDialog,
  openProjectProfileDialog,
  closeProjectProfileDialog,
} from '../store';
import useParticipationDetails from '../../../utils/useParticipationDetails';
import useNewParticipation from '../../../utils/useNewParticipation';

const ConnectedProjectProfileDialog = ({
  'data-testid': testId,
  projectId: defaultProjectId,
}) => {
  const dispatch = useDispatch();
  const handleOnCancel = useCallback(() => {
    dispatch(closeProjectProfileDialog());
  }, [dispatch]);
  const options = useSelector(getProjectProfileDialog);
  const {
    projectId = defaultProjectId,
    recipientId,
    participationId,
  } = options || {};

  const handleOnChangeProjectId = useCallback(
    (newProjectId) => {
      dispatch(
        openProjectProfileDialog({
          projectId: newProjectId,
          recipientId,
          participationId,
        }),
      );
    },
    [recipientId, participationId, dispatch],
  );

  const {
    project,
    variables,
    recipient,
    participation,
    participationDetailsReady,
  } = useParticipationDetails({
    projectId,
    recipientId,
    participationId,
  });

  const { newParticipation, newParticipationReady } =
    useNewParticipation(projectId);

  const loading =
    !options || !participationDetailsReady || !newParticipationReady;

  return (
    <ProjectProfileDialog
      data-testid={testId}
      project={project}
      variables={variables}
      recipient={recipient}
      participation={participation || newParticipation}
      onCancel={handleOnCancel}
      onChangeProjectId={handleOnChangeProjectId}
      loading={loading}
      visible={!!options}
    />
  );
};

ConnectedProjectProfileDialog.propTypes = {
  'data-testid': PropTypes.string,
  projectId: PropTypes.string,
};

ConnectedProjectProfileDialog.defaultProps = {
  'data-testid': null,
  projectId: null,
};

export default ConnectedProjectProfileDialog;
